export default "__VITE_ASSET__D8APxB7X__"